<template>
  <div class="box">
    <div class="vr">
      <div class="body">
        <div class="top">
          <div class="vrpng" v-if="lang == 'zh'">
            <img src="../../../static/chinaCoalMobile.png" alt="" />
          </div>
          <div v-else class="vrEnglishPng">
            <span>China</span>
            <span>Coal</span>
            <span>&</span>
            <span>Mining</span>
            <span>Expo</span>
            <span>2023</span>
          </div>
          <div class="txt">
            {{ $t("homePage.vr.txt") }}
          </div>
        </div>
        <div class="bottom">
          <router-link to="#">
            <img
              src="../../../static/vrCloudChinese.png"
              alt=""
              class="backImg"
              @click="jumpVr()"
              v-if="lang == 'zh'"
            />
            <img
              src="../../../static/vrCloudChinese.png"
              alt=""
              class="backImg"
              @click="jumpVr()"
              v-else
            />
            <img
              src="../../../static/btnVR.png"
              alt=""
              class="VRbtn"
              @click="jumpVr()"
            />
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { testDomain } from "../../../../utils/common";
export default {
  name: "vrSee",
  data() {
    return {
      lang: "zh",
      testBaseDomain: testDomain(),
    };
  },
  created() {
    const language = localStorage.getItem("lang");
    this.lang = language == "en" ? language : "zh";
  },
  methods: {
    jumpVr() {
      window.open(
        this.testBaseDomain + "index?slanguage=" + this.lang,
        "_self"
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.box {
  background-color: #f6f6f7;
  // height: 125.2vw;
  .vr {
    width: 100%;
    // height: 125.2vw;
    background: url("../../../static/VR背景图.png") no-repeat;
    background-size: 100% 100%;
    padding: 4vw 3.9vw 6.6vw 4.13vw;
    box-sizing: border-box;
    .body {
      width: 100%;
      margin: 0 auto;
      justify-content: space-between;
      align-items: center;

      .top {
        height: fit-content;
        .vrpng {
          width: 68%;
          height: 12vw;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          img {
            width: 100%;
            height: 100%;
          }
        }
        .vrEnglishPng {
          font-size: 25px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #fdd72a;
          line-height: 30px;
          span {
            margin: 0px 3px;
          }
        }
        .txt {
          padding-top: 3.3vw;
          font-size: 3.2vw;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #ffffff;
          line-height: 24px;
        }
      }

      .bottom {
        width: 92vw;
        height: 61.4vw;
        margin-top: 7vw;
        z-index: 10;
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        .backImg {
          // width: 100%;
          // height: 100%;
          z-index: 10;
          max-width: 100%;
          max-height: 100%;
          vertical-align: middle;
        }
        .VRbtn {
          width: 7vw;
          height: 8.6vw;
          z-index: 10;
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
        }
      }
    }
  }
}
</style>
